import React, { Component } from 'react';

function getInquiryApiUrl() {
    if (process.env.REACT_APP_API_URL) {
        return `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/public/inquiries`;
    }
    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:3000/api/public/inquiries';
    }
    return 'https://dashboard.converzex.com/api/public/inquiries';
}

class InquiryForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            company: '',
            number: '',
            designation: '',
            website: '',
            loading: false,
            successMsg: '',
            errorMsg: '',
        };
    }

    componentDidMount() {
        this.chatbotTimer = setTimeout(() => {
            const chatbot = document.getElementById('chatbot-float-btn');
            if (chatbot) {
                chatbot.style.setProperty('display', 'none', 'important');
            }
        }, 500);
    }

    componentWillUnmount() {
        clearTimeout(this.chatbotTimer);
        const chatbot = document.getElementById('chatbot-float-btn');
        if (chatbot) {
            chatbot.style.setProperty('display', 'flex', 'important');
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, errorMsg: '', successMsg: '' });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { name, email, company, number, designation, website } = this.state;

        if (!name.trim()) {
            this.setState({ errorMsg: 'Please enter your full name.' });
            return;
        }
        if (!email.trim()) {
            this.setState({ errorMsg: 'Please enter your email address.' });
            return;
        }

        this.setState({ loading: true, errorMsg: '', successMsg: '' });

        try {
            const res = await fetch(getInquiryApiUrl(), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: name.trim(),
                    email: email.trim(),
                    company: company.trim() || undefined,
                    number: number.trim() || undefined,
                    designation: designation.trim() || undefined,
                    website: website.trim() || undefined,
                }),
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok || !data.success) {
                const errText = data.message || data.msg || 'Failed to submit inquiry. Please try again.';
                throw new Error(errText);
            }

            this.setState({
                loading: false,
                successMsg: data.message || 'Thank you! Your inquiry has been submitted successfully.',
                name: '',
                email: '',
                company: '',
                number: '',
                designation: '',
                website: '',
            });
        } catch (err) {
            this.setState({
                loading: false,
                errorMsg: err.message || 'Something went wrong. Please try again later.',
            });
        }
    };

    render() {
        const publicUrl = process.env.PUBLIC_URL + '/';
        const { name, email, company, number, designation, website, loading, successMsg, errorMsg } = this.state;

        return (
            <div>
                <section className="contact-two">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <form className="contact-two__form" onSubmit={this.handleSubmit} noValidate>
                                    <div className="contact-two__block row d-flex justify-content-between px-2">
                                        <div>
                                            <h3>Get In Touch</h3>
                                            <p>
                                                Get in touch with our team for a personalized demo and consultation.
                                            </p>
                                        </div>
                                        <img
                                            className="image-40"
                                            src={publicUrl + 'assets/images/logo/brand-1.png'}
                                            alt="Logo"
                                        />
                                    </div>

                                    {successMsg && (
                                        <div className="alert alert-success" role="alert" style={{ borderRadius: 8, marginBottom: 16 }}>
                                            {successMsg}
                                        </div>
                                    )}
                                    {errorMsg && (
                                        <div className="alert alert-danger" role="alert" style={{ borderRadius: 8, marginBottom: 16 }}>
                                            {errorMsg}
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="Full Name *"
                                                value={name}
                                                onChange={this.handleChange}
                                                disabled={loading}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Email *"
                                                value={email}
                                                onChange={this.handleChange}
                                                disabled={loading}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="company"
                                                placeholder="Company"
                                                value={company}
                                                onChange={this.handleChange}
                                                disabled={loading}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="number"
                                                placeholder="Phone Number"
                                                value={number}
                                                onChange={this.handleChange}
                                                disabled={loading}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="designation"
                                                placeholder="Designation"
                                                value={designation}
                                                onChange={this.handleChange}
                                                disabled={loading}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="website"
                                                placeholder="Website"
                                                value={website}
                                                onChange={this.handleChange}
                                                disabled={loading}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <button
                                                type="submit"
                                                className="thm-btn contact-two__btn"
                                                disabled={loading}
                                                style={{ opacity: loading ? 0.7 : 1 }}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                            style={{ marginRight: 8, verticalAlign: 'middle' }}
                                                        />
                                                        Sending...
                                                    </>
                                                ) : (
                                                    <>
                                                        Send Message <i className="fa fa-angle-double-right" />
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default InquiryForm;
